<template>
  <div class="circlefollowbox">
    <van-sticky>
      <div class="circletabbox">
        <ul class="circleul">
          <li :class="liindex==0 ? 'active' : '' " @click="gotourl(0)">
            <span>推荐</span>
          </li>
          <li :class="liindex==1 ? 'active' : '' " @click="gotourl(1)">
            <span>关注</span>
          </li>
          <li :class="liindex==2 ? 'active' : '' " @click="gotourl(2)">
            <span>最近访问</span>
          </li>
        </ul>
      </div>

      <div class="followtitlebox">
        <div class="followtitle">常用圈子</div>
      </div>
    </van-sticky>

    <div class="followmain">
      <div class="nofollowbox" v-if="noRecentvisits">
        <div class="nofollowpic">
          <img src="../../assets/images/circle_icon_wu.png" />
        </div>
        <div class="gotofollow" @click="gotocirclelist">
          <button>立即去访问</button>
        </div>
      </div>

      <div v-else>
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <div class="circle-cell" v-for="(item,index) in Recentvisits" :key="index">
            <div class="circle-cell-pic" @click="gotocirclecontent(item.like_id)">
              <img :src="item.avatar_url" />
            </div>
            <div class="circle-cell-name" @click="gotocirclecontent(item.like_id)">
              <div class="cname">{{item.title}}</div>
              <div class="cconner"></div>
            </div>
            <div class="circle-cell-fllow">
              <button @click="favorclick(item.like_id)" v-if="item.is_follow%2==0">关注</button>
              <button @click="favorclick(item.like_id)" class="active" v-else>已关注</button>
            </div>
          </div>
        </van-list>
      </div>
    </div>
  </div>
</template>

<script>
import { circlerecentvisits, gettofollowcircle } from "../../api/api";
import Vue from 'vue';
import { Toast, List } from "vant";

Vue.use(List);
export default {
  data () {
    return {
      Recentvisits: [],
      noRecentvisits: true, //没有最近访问的圈子
      liindex: 2,
      loading: false,
      finished: false,
      titlename: "最近访问"
    };
  },
  created () {
    document.title = this.titlename;
  },
  mounted () {
    Toast.loading({
      mask: true,
      message: "加载中..."
    });
    this.rencentvisitsgogo();

    this.changetabbar();
  },
  methods: {
    onLoad () {
      // 异步更新数据
      setTimeout(() => {
        var page = this.page;
        let that = this;
        let pageCount = this.pageCount;
        page++;
        if (page > pageCount) {
          return;
        }
        this.page = page;

        circlerecentvisits(page).then(res => {
          if (res.data.code == 200) {
            this.loading = false;
            let recentvisits = that.Recentvisits;
            let newarr = res.data.data.list;
            newarr.forEach(function (e) {
              recentvisits.push(e);
            });
            this.finished = true;
          }
        });
      }, 500);
    },
    //获取最近访问的圈子
    gotofollow () { },

    rencentvisitsgogo () {
      let that = this;
      let page = 0;
      circlerecentvisits(page)
        .then(res => {
          if (res.data.code == 200) {
            if (res.data.data.list.length != 0) {
              that.Recentvisits = res.data.data.list;
              that.pageCount = res.data.data.pageCount;
              that.page = 0;
              that.noRecentvisits = false;
              Toast.clear();

            } else {
              that.noRecentvisits = true;
              Toast.fail("加载失败，请刷新！");
            }
            that.finished = false;
            that.loading = false;
          }
        })
        .catch(err => {
        });
    },

    gotocirclelist () {
      this.$router.push({
        name: "circlelist"
      });
    },
    gotocirclecontent (id) {
      this.$router.push({
        path: "/circlecontent",
        query: {
          id: id
        }
      });
    },
    favorclick: function (id) {
      var item_id = id; //此处找到列表的id

      this.goodfllow(item_id);
    },

    //关注圈子和取消关注圈子
    goodfllow: function (item_id) {
      var that = this;
      var show; //传递到数据库点赞的状态
      if (localStorage.getItem("okfollow")) {
        var cookie_mid = localStorage.getItem("okfollow").split(",");
      } else {
        var cookie_mid = [];
      }
      //var cookie_mid = localStorage.getItem('okfollow').split(',') || []; //获取全部点赞的mid
      var newmessage = [];

      for (var i = 0; i < that.Recentvisits.length; i++) {
        if (that.Recentvisits[i].like_id == item_id) {
          //遍历找到对应的id
          var num = that.Recentvisits[i].is_follow; //当前赞数
          var isshow; //点赞的状态
          if (cookie_mid.includes(item_id)) {
            //说明已经点过赞,取消赞

            for (var j = 0; j < cookie_mid.length; j++) {
              if (cookie_mid[j] == item_id) {
                cookie_mid.splice(j, 1); //删除取消赞的mid
              }
            }
            --num;
            isshow = 0; //点赞的状态
            that.Recentvisits[i].is_follow = num;
            localStorage.setItem("okfollow", cookie_mid.join(","));
          } else {
            isshow = 1; //点赞的状态
            ++num;
            that.Recentvisits[i].is_follow = num;
            cookie_mid.unshift(item_id); //新增赞的mid
            localStorage.setItem("okfollow", cookie_mid.join(","));
          }
        }
      }

      gettofollowcircle(item_id).then(res => {
        if (res.code == 200) {
          Toast({
            message: res.message,
            icon: "success"
          });
        } else {
          Toast.fail("关注失败！");
        }
      });
    },

    gotourl: function (liindex) {
      switch (liindex) {
        case 0:
          this.$router.push({ name: "circlelist" });
          //this.liindex = 0;
          break;
        case 1:
          this.$router.push({ name: "circlefollow" });
          //this.liindex = 1;
          break;
        case 2:
          this.$router.push({ name: "circlevisit" });
          //this.liindex = 2;
          break;
      }
    },
    changetabbar: function () {
      //判断当前的路由所在区域给
      this.onPath = this.$route.path;
      if (this.onPath == "/circlevisit") {
        this.liindex = 2;
      } else if (this.onPath == "/circlefollow") {
        this.liindex = 1;
      } else if (this.onPath == "/circlelist") {
        this.liindex = 0;
      }
    }
  }
};
</script>

<style scoped>
.circlefollowbox {
  background: #fff;
  height: 100%;
}
.circlefollowbox .followtitlebox {
  background: #fff;
  padding-top: 0.8108108108108109rem;
  padding-bottom: 0.35rem;
}
.circlefollowbox .followtitle {
  font-size: 0.8108108108108109rem;
  border-left: 0.2702702702702703rem solid #ffbd0a;
  padding-left: 0.5405405405405406rem;
  font-weight: bold;
  color: #333;
  margin-left: 0.9459459459459459rem;
  background: #fff;
}
.circlefollowbox .followmain {
  padding-left: 0.9459459459459459rem;
  padding-right: 0.7027027027027027rem;
  padding-bottom: 3rem;
}
.circlefollowbox .circle-cell {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  padding-top: 0.8108108108108109rem;
  padding-bottom: 0.8108108108108109rem;
  border-bottom: 0.02702702702702703rem solid #f6f6f6;
  width: 100%;
}
.circlefollowbox .circle-cell .circle-cell-pic {
  width: 2.16rem;
  height: 2.16rem;
  border-radius: 0.2702702702702703rem;
  overflow: hidden;
  position: relative;
}

.circlefollowbox .circle-cell .circle-cell-pic .circle-cell-pic-no {
  position: absolute;
  bottom: 0;
  background: rgba(218, 135, 70, 0.9);
  height: 0.7027027027027027rem;
  line-height: 0.7027027027027027rem;
  width: 2.16rem;
  color: #fff;
  font-size: 0.4864864864864865rem;
  text-align: center;
  border-radius: 0 0 0.2702702702702703rem 0.2702702702702703rem;
}
.circlefollowbox .circle-cell .circle-cell-pic img {
  width: 2.108108108108108rem;
  height: 2.108108108108108rem;
  border-radius: 0.2702702702702703rem;
}
.circlefollowbox .circle-cell .circle-cell-pic .circle-cell-pic-no img {
  width: 0.7567567567567568rem;
  height: 0.5675675675675675rem;
}
.circlefollowbox .circle-cell .circle-cell-pic .circle-cell-pic-no01 {
  background: rgba(246, 210, 84, 0.9);
  color: #eb7c3a;
}
.circlefollowbox .circle-cell .circle-cell-pic .circle-cell-pic-no02 {
  background: rgba(211, 224, 241, 0.9);
  color: #7a98b4;
}
.circlefollowbox .circle-cell .circle-cell-pic .circle-cell-pic-no03 {
  background: rgba(238, 147, 120, 0.9);
  color: #b04b32;
}
.circlefollowbox .circle-cell .circle-cell-name {
  flex: 7;
  padding-right: 0.2702702702702703rem;
  padding-left: 0.5rem;
}
.circlefollowbox .circle-cell .circle-cell-name .cname {
  font-size: 0.7567567567567568rem;
}
.circlefollowbox .circle-cell .circle-cell-name .cconner {
  font-size: 0.65rem;
  color: #999999;
  padding-top: 0.32rem;
}
.circlefollowbox .circle-cell .circle-cell-name .ctext1 {
  font-size: 0.6486486486486487rem;
  color: #999999;
}
.circlefollowbox .circle-cell .circle-cell-name .ctext2 {
  font-size: 0.6486486486486487rem;
  color: #999999;
  padding-left: 0.5405405405405406rem;
}
.circlefollowbox .circle-cell .circle-cell-fllow {
  float: 3.5;
  padding-top: 0.2702702702702703rem;
  margin-top: 0.2rem;
}
.circlefollowbox .circle-cell .circle-cell-fllow button {
  font-size: 0.6216216216216216rem;
  background: #ffbd0a;
  border: none;
  width: 3.2432432432432434rem;
  height: 1.35rem;
  border-radius: 5px;
  display: block;
  color: #fff;
  padding: 0;
}
.circlefollowbox .circle-cell .circle-cell-fllow button.active {
  background: #dbdbdb;
  border: none;
}

.nofollowbox {
  padding-top: 7.837837837837838rem;
}
.nofollowbox .nofollowpic {
  text-align: center;
}
.nofollowbox .nofollowpic img {
  width: 7.837837837837838rem;
  height: 6.243243243243243rem;
}
.nofollowbox .gotofollow {
  padding-top: 1.2702702702702702rem;
  text-align: center;
}
.nofollowbox .gotofollow button {
  width: 5.405405405405405rem;
  height: 1.8918918918918919rem;
  background: linear-gradient(to right, rgb(255, 189, 10), rgb(248, 218, 91));
  font-size: 0.7rem;
  color: #fff;
  border: none;
  border-radius: 1rem;
  margin: 0 auto;
}

.circletabbox .circleul {
  display: flex;
  justify-content: space-around;
  border-bottom: 1px solid #efefef;
  background: #fff;
  padding: 0 1.2rem;
  padding-top: 0.5rem;
}
.circletabbox .circleul li {
  font-size: 0.81rem;
  text-align: center;
  color: #666666;
  flex: 0 0 33.333%;
}
.circletabbox .circleul li span {
  padding: 0.5rem 0;
  display: inline-block;
}
.circletabbox .circleul li.active {
  color: #ffbd0a;
}
.circletabbox .circleul li.active span {
  border-bottom: 3px solid #ffbd0a;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/circlevisit.vue